import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { ROUTE_ITINERARY_HOME } from '../../routes'
import { navigateTo } from '../../store/history/history.actions'
import { selectItineraryOptions } from '../../store/history/history.navigate.selectors'
import itineraryIcon from '../genericComponents/assets/itinerary.svg?raw'
import T from '../i18n/T'
import { generateFullRoute } from '../router/routeUtils'
import { useAction } from '../utils/react-redux'
import s from './ItineraryUniverseButton.less'

const ItineraryUniverseButton = () => {
  const { route, routeOptions } = useSelector(selectItineraryOptions)

  const execNavigateTo = useAction(navigateTo)

  const onButtonClick = useCallback(
    e => {
      e.preventDefault()
      execNavigateTo({ route, routeOptions })
    },
    [execNavigateTo, route, routeOptions]
  )

  return (
    <a href={generateFullRoute(ROUTE_ITINERARY_HOME)} className={s.root} onClick={route && onButtonClick}>
      <div className={s.button} dangerouslySetInnerHTML={{ __html: itineraryIcon }}></div>
      <div className={s.text}>
        <T id="universes.itineraries" />
      </div>
    </a>
  )
}

export default ItineraryUniverseButton
